import { render, staticRenderFns } from "./exercises.vue?vue&type=template&id=b864e04c&scoped=true&"
import script from "./exercises.vue?vue&type=script&lang=js&"
export * from "./exercises.vue?vue&type=script&lang=js&"
import style0 from "./exercises.vue?vue&type=style&index=0&id=b864e04c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b864e04c",
  null
  
)

export default component.exports